// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BulkFollowListModal-cls1___9e68b070ad44aabeefa{/*!*/}.BulkFollowListModal-cls2__f2cb8e4e9a9be8871afa{width:100%;max-width:90%;padding:24px;color:#223}@media(min-width: 768px){.BulkFollowListModal-cls2__f2cb8e4e9a9be8871afa{max-width:633px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "BulkFollowListModal-cls1___9e68b070ad44aabeefa",
	"cls2": "BulkFollowListModal-cls2__f2cb8e4e9a9be8871afa BulkFollowListModal-cls1___9e68b070ad44aabeefa"
};
export default ___CSS_LOADER_EXPORT___;
